import { DateTime } from 'luxon'
import { makeAutoObservable } from 'mobx'
import * as apiClient from 'src/utils/apiClient/webApplications'

type RegisterParams = Omit<apiClient.RegisterParams, 'birthDate' | 'moveInOn'> & {
  birthDate: DateTime
  moveInOn: DateTime
}

export default class WebApplicationStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  getAccountTransferEditParams = async (params: apiClient.GetAccountTransferEditParamsParams) => {
    return await apiClient.getAccountTransferEditParams(params)
  }

  getCreditCardEditURL = async (params: apiClient.GetCreditCardEditURLParams) => {
    const { url } = await apiClient.getCreditCardEditURL(params)
    return url
  }

  register = async (params: RegisterParams) => {
    const { info } = await apiClient.register({
      ...params,
      birthDate: params.birthDate.toFormat('yyyy-MM-dd'),
      moveInOn: params.moveInOn.toFormat('yyyy-MM-dd'),
    })
    return info
  }
}
